import type { Assessment } from "../interfaces/AssessmentInterfaces";

type EmergencyAssessmentLike = Partial<Assessment> & {
  emergencyId?: number | null;
  emergency?: unknown;
  emergencyAssessmentVitals?: unknown[] | null;
  assessmentDocument?: Partial<Assessment> & {
    emergencyId?: number | null;
    emergency?: unknown;
    emergencyAssessmentVitals?: unknown[] | null;
  };
};

export const isEmergencyAssessment = (assessment?: EmergencyAssessmentLike | null): boolean => {
  if (!assessment) return false;

  const assessmentDocument = assessment.assessmentDocument || {};

  return Boolean(
    assessment.emergencyId ||
      assessmentDocument.emergencyId ||
      assessment.emergency ||
      assessmentDocument.emergency ||
      assessment.emergencyAssessmentVitals?.length ||
      assessmentDocument.emergencyAssessmentVitals?.length
  );
};

export const filterOpdAssessments = (assessments: Assessment[] = []): Assessment[] =>
  assessments.filter((assessment) => !isEmergencyAssessment(assessment));
